import { render, staticRenderFns } from "./regionReportDetails.vue?vue&type=template&id=1fde8ee8&scoped=true"
import script from "./regionReportDetails.vue?vue&type=script&lang=js"
export * from "./regionReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fde8ee8",
  null
  
)

export default component.exports